// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore } from '@atlassian/react-sweet-state';
import actions from './actions.tsx';
import type { State } from './types.tsx';

const initialState: State = {
	isOpen: false,
};

export default createStore<State, typeof actions>({
	name: 'modals',
	initialState,
	actions,
});
